import Vue from 'vue';

export default {
    methods: {
        registerFixClickCallback(columns, callback) {
            let self = this;
            columns.map(function(column) {
                column.meta        = column.meta        || {};
                column.meta.events = column.meta.events || {};                
                column.meta.events.onPinClick = function(event) {
                    event.stopPropagation();
                    if( typeof callback === 'function' ) {
                        Vue.nextTick(() => callback(this))
                    }
                } 
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/table_v3/mixin/fixable.mixin.js